// Scroll to Gravity Forms confirmation on submit and on page load fallback
(function () {
  function getOffsetTop(el) {
    var top = 0;
    while (el) {
      top += el.offsetTop || 0;
      el = el.offsetParent;
    }
    return top;
  }

  function getHeaderOffset() {
    var header = document.querySelector('.site-header, header');
    return header ? header.offsetHeight : 0;
  }

  function smoothScrollTo(element) {
    if (!element) return;
    var y = getOffsetTop(element) - (getHeaderOffset() + 16);
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
  }

  function findConfirmation(formId) {
    var selectors = [
      '#gform_confirmation_message_' + formId,
      '.gform_confirmation_message_' + formId,
      '.gform_confirmation_wrapper_' + formId,
      '.gform_confirmation_' + formId,
      '.gform_confirmation_message',
      '.gform_confirmation_wrapper',
      '.gform_confirmation'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function onConfirmationLoaded(event, formId) {
    // Gravity Forms jQuery event passes (event, formId)
    // Try to find the confirmation container and scroll to it
    setTimeout(function () {
      smoothScrollTo(findConfirmation(formId));
    }, 50);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    // Hook: fires after AJAX/inline confirmation is rendered
    if (window.jQuery) {
      window.jQuery(document).on('gform_confirmation_loaded', onConfirmationLoaded);
    }

    // Fallback: on page load if confirmation already present (non-AJAX or redirected)
    setTimeout(function () {
      var existing = document.querySelector('.gform_confirmation_message, .gform_confirmation_wrapper, .gform_confirmation');
      if (existing) smoothScrollTo(existing);
    }, 150);
  });
})();


